(() => {
  const initialize = () => {
    if (window !== window.top || window.Shopify?.shop !== 'caddxfpv.myshopify.com' ||
        window.Shopify?.designMode || window.CaddxPopupLayout) return;

    const state = window.CaddxPopupLayout = {seeded: 0, released: 0, fallbackReleased: 0};
    const property = '--image-height-on-mobile';
    const roots = new Set(), observers = new Set(), images = new Set();
    const completed = new WeakSet(), pending = new Map();
    let stopped = false, queued = false, documentObserver, expiry;

    const stop = () => {
      if (stopped) return;
      stopped = true;
      documentObserver?.disconnect();
      observers.forEach(observer => observer.disconnect());
      observers.clear(); roots.clear(); images.clear();
      clearTimeout(expiry);
      pending.forEach((entry, image) => {
        clearTimeout(entry.timer);
        if (image.style.getPropertyValue(property) === entry.value) image.style.removeProperty(property);
      });
      pending.clear();
    };
    const release = (image, nativeReady) => {
      const entry = pending.get(image);
      if (!entry) return;
      clearTimeout(entry.timer);
      if (image.style.getPropertyValue(property) === entry.value) image.style.removeProperty(property);
      pending.delete(image);
      state.released++;
      if (!nativeReady) state.fallbackReleased++;
      if (state.seeded && !pending.size) stop();
    };
    const nativeHeightReady = image => {
      if (!String(image.imageHeight).endsWith('px')) return false;
      return Array.from(image.shadowRoot?.querySelectorAll('style') || []).some(style => {
        if (!style.textContent.includes(property)) return false;
        try {
          return Array.from(style.sheet?.cssRules || []).some(rule => {
            const value = rule.selectorText === ':host' && rule.style.getPropertyValue(property).trim();
            return value && value.endsWith('px') && parseFloat(value) > 0;
          });
        } catch { return false; }
      });
    };
    const queue = () => {
      if (stopped || queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; synchronize(); });
    };
    const watch = root => {
      if (!root || roots.has(root) || stopped) return;
      roots.add(root);
      const observer = new MutationObserver(queue);
      observer.observe(root, {childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['style', 'class']});
      observers.add(observer);
    };
    const synchronize = () => {
      if (stopped) return;
      pending.forEach((entry, image) => {
        if (nativeHeightReady(image)) release(image, true);
      });
      if (stopped) return;
      for (const root of roots) {
        root.querySelectorAll('window-popup-frame, window-popup-image').forEach(element => {
          watch(element.shadowRoot);
          if (element.localName === 'window-popup-image') images.add(element);
        });
      }
      images.forEach(image => {
        if (completed.has(image) || image.renderMode === 'standalone' || image.autoHeight ||
            image.imageWidth !== '100%' || !image.showMedia || !image.showMediaMobile ||
            image.style.getPropertyValue(property)) return;
        // Use this app's verified existing rule; a changed implementation keeps
        // its normal behavior. No application prototype or setting is changed.
        const calculation = String(image.calculateImageHeightByImagePosition).replace(/\s/g, '');
        if (!calculation.includes('requestAnimationFrame') ||
            !calculation.includes('/(100-this.imageSettings.size)*this.imageSettings.size')) return;
        if (!['auto', '100%'].includes(String(image.imageHeight))) return;
        const size = Number(image.imageSettings?.size);
        const form = image.parentElement?.querySelector('.announcement-content-text');
        const height = form?.offsetHeight;
        if (!(size > 0 && size < 100 && height > 0)) return;
        if (getComputedStyle(image).getPropertyValue(property).trim() !== String(image.imageHeight)) return;
        const value = `${height / (100 - size) * size}px`;
        completed.add(image);
        state.seeded++;
        image.style.setProperty(property, value);
        pending.set(image, {value, timer: setTimeout(() => release(image, false), 300)});
      });
    };
    const discover = () => {
      if (stopped) return;
      const hosts = document.querySelectorAll('email-signup-popup');
      hosts.forEach(host => watch(host.shadowRoot));
      if (hosts.length && Array.from(hosts).every(host => host.shadowRoot)) documentObserver?.disconnect();
      synchronize();
    };
    documentObserver = new MutationObserver(discover);
    documentObserver.observe(document.documentElement, {childList: true, subtree: true});
    expiry = setTimeout(stop, 60000);
    window.addEventListener('pagehide', stop, {once: true});
    customElements.whenDefined('email-signup-popup').then(discover);
    customElements.whenDefined('window-popup-frame').then(queue);
    customElements.whenDefined('window-popup-image').then(queue);
    discover();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
